import React, { useState } from "react";
import { translate } from "../../../../../../common/providers";
import { CustomButton, CustomIconButton, icon } from "../../../../../../common/components";
import styles from "./DSICompanyUpdateSidePanel.module.css";
import DSICompanyBuCreationDialog from "../creation-dialog/DSICompanyBuCreationDialog";
import { DSIQuotasBlock } from "./components";

const DSICompanyUpdateSidePanel = ({ onExportTemplates, onImportTemplates, onUpdateCompany, selectedCompany }) => {
	const [openCreationDialog, setOpenCreationDialog] = useState(false);
	const handleOpenCreationDialog = () => {
		setOpenCreationDialog(true);
	};
	const handleCloseCreationDialog = () => {
		setOpenCreationDialog(false);
	};
	const handleUpdateCompany = (name) => {
		onUpdateCompany(selectedCompany.id, { name, shortName: name });
	};
	return (
		<div className={styles.container}>
			<div>
				<div className={styles.nameContainer}>
					<div className={styles.title}>{translate("dsi.dsi-company.th.name")}*</div>
					<div className={styles.name}>
						<span>{selectedCompany?.companyName}</span>
						<CustomIconButton icon={icon.faPen} size="sm" onClick={handleOpenCreationDialog} />
					</div>
				</div>
				<DSIQuotasBlock selectedCompany={selectedCompany} />
			</div>
			<div>
				<div className={styles.title}>{translate("dsi.dsi-company.category-templating")}</div>
				<div>
					<CustomButton
						className={styles.btn}
						component="label"
						startIcon={icon.faCloudArrowUp}
						variant="outlined"
					>
						<input hidden accept=".json" type="file" onChange={onImportTemplates} />
						{translate("dsi.dsi-company.category-templating.import")}
					</CustomButton>
					<CustomButton
						className={styles.btn}
						startIcon={icon.faDownload}
						variant="outlined"
						onClick={onExportTemplates}
					>
						{translate("dsi.dsi-company.category-templating.download")}
					</CustomButton>
				</div>
			</div>
			<DSICompanyBuCreationDialog
				defaultName={selectedCompany?.companyName}
				open={openCreationDialog}
				onClose={handleCloseCreationDialog}
				onCreate={handleUpdateCompany}
			/>
		</div>
	);
};

export default DSICompanyUpdateSidePanel;
